import React, { useEffect } from 'react';

import TeamInvite from '../components/Layout/TeamInvite';
import UserCard from '../components/Team/UserCard';
import Invite from '../components/Team/Invite';

import { Box, Typography, Paper, Button } from '@mui/material';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../hooks/useAuth';
import { useOrganization } from '../hooks/useOrganization';
import { Navigate, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { MailPlus, Mail, Users } from 'lucide-react';



const Team = () => {
  const { theme } = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { organization, fetchTeam, fetchTeamInvites, team, teamInvites } = useOrganization();

  useEffect(() => {
        fetchTeam(user.organization._id);
    fetchTeamInvites(user.organization._id);
    
  }, []);

  

  // Redirect if user is not admin
  if (!user?.roles?.includes('admin') && !user?.roles?.includes('superadmin')) {
    return <Navigate to="/" replace />;
  }

  const handleInviteClick = () => {
    // Only navigate if not already on the invite page
    if (location.pathname !== '/team/invite') {
      navigate('/team/invite');
    }
  };

  return (
    <div className="main-content page-team">
      <Routes>
        <Route path="/invite" element={<TeamInvite invite="user"/>} />
      </Routes>
      <div style={{position: "absolute", top: 10, right: 10}}>
        <Button 
          variant="contained" 
          color="primary"
          onClick={handleInviteClick}
        >
          <MailPlus className="nav-icon" style={{marginRight: 11}} size={16} /> Invite User
        </Button>
      </div>
      <div>
       
        <div className="flex-row align-center">
          <Users size={16} style={{ color: 'var(--icon-color-secondary)' }} />
          <h4 style={{ margin: 0, marginLeft: 10 }}>
            Users
          </h4>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 10, gap: 0 }}>
          {team.map((t) => (
            <UserCard key={t._id} user={t} />
          ))}
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
       
        <div className="flex-row align-center">
          <Mail size={16} style={{ color: 'var(--icon-color-secondary)' }} />
          <h4 style={{ margin: 0, marginLeft: 10 }}>
            Invites
          </h4>
        </div>
        <div style={{ marginTop: 10 }}>
          {teamInvites.map((invite) => (
            <Invite
              key={invite._id}
              invite={invite}
            />
          ))}
          {teamInvites.length === 0 && (
            <Typography variant="body1" color="textSecondary">
              No pending team invites.
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default Team; 
